import { Component } from '@angular/core';

@Component({
  selector: 'app-footer-svg',
  templateUrl: './footer-svg.component.html',
  styleUrls: ['./footer-svg.component.scss']
})
export class FooterSvgComponent {

  constructor() { }

}
